export {};

import Widgets from 'js-widget-hooks';

import '../../../../src/Resources/core/jsx/components/widgets';

const DWBF_VARS = {
  BG_IMAGES: {
    'top-nav-1': '/buddhism-foundation/img/hg_01_stiftung.jpg',
    'top-nav-2': '/buddhism-foundation/img/hg_02_zentren.jpg',
    'top-nav-3': '/buddhism-foundation/img/hg_03_projekte.jpg',
    'top-nav-4': '/buddhism-foundation/img/hg_04_buddhismus.jpg',
    'top-nav-default': '/buddhism-foundation/img/hg_04_buddhismus.jpg',
  },
};

/**
 * 	Default widgets initilization
 */
$(document).ready(function () {
  PageHandle.init();
  Widgets.init();
  PageHandle.testHashState();
});

/*
var LegacyWidgets = {

	  widgetClass : 'widget'
	, scriptClass : 'dyn-script'
	, states : {
		  'overlayCount' : 0
		, 'ajaxCalls' : {}
	}

	, vars: {} // place to put data

	, scripts : {
		  fancybox  : '/system/modules/org.dwbn.easysite.v8.mit.resources/resources/js/jquery.fancybox.pack.js'
		, teaser    : '/system/modules/org.dwbn.easysite.v8.mit.resources/resources/js/jquery.teaser.js'
		, videoinit : '/system/modules/org.dwbn.easysite.v8.mit.resources/resources/js/JWPlayer/videoinit.js'
		, innerfade : '/system/modules/org.dwbn.easysite.v8.mit.resources/resources/js/jquery.innerfade.js'
		, gMaps		: '/system/modules/org.dwbn.easysite.v8.mit.resources/resources/js/jquery.gMaps.js'
	}

	, registered : {
		  'ajaxlink' : ['fancybox' , function(elem) {
			var	href 		= new URL(elem.attr('href'))
			  ,	overlayed 	= false
			  , fancyParams	= {
					  padding	: 6
					, fitToView	: true
					, width		: '70%'
					, height	: '70%'
					, autoSize	: false
					, closeClick: false
				}
			  ,	overlayID	= 'show-overlay-'
			;

			LegacyWidgets.states.overlayCount++;
			overlayID += LegacyWidgets.states.overlayCount; // fancyBox takes a href with a hash # as id of a inline box element. Due to this we create a hidden element as inline box before clicking

			if (href) {

				href.addParameter('format', 'ajax');
				elem.attr('href', '#' + overlayID);

				if (elem.fancybox && !overlayed) {
					elem.fancybox(fancyParams);
					overlayed = true;
				}

				elem.bind('click', function(e) {

					var	container = $('#' + overlayID)
					;

					if (! container.length) {
						container = $('<div id="' + overlayID + '"></div>').hide();
						$('body').append(container);
					}

					// make sure, that we do not have a double clickhandler attached
					if (! LegacyWidgets.states.ajaxCalls[overlayID]) {
						LegacyWidgets.states.ajaxCalls[overlayID] = true;
						// do the ajax call for the content
						$.get(href.toString(), function(data){

							container.html(data)

							if (elem.fancybox && !overlayed) {
								elem.fancybox(fancyParams)
								overlayed = true;
								elem.click();
							}

							LegacyWidgets.states.ajaxCalls[overlayID] = false;
						});
					}
				});
			}
		}]

		, 'scale-img' : [false, function(elem){

				LegacyWidgets.vars.images = LegacyWidgets.vars.images ? LegacyWidgets.vars.images.add(elem) : elem;

			}]
		, 'popup' : ['fancybox', function(elem){
				var config = myEval(elem.data('config'))
				  , url
				  , fancyParams = {
						helpers: {
							title : {
								type : 'float'
							}
						}
					}
				;

				if (config && config.mode == 'ajax') {
					elem.click(function(e){
						e.preventDefault();

						url = new URL(elem.attr('href'));
						url.addParameter('format', 'ajax').makeRelative(); // we make the url relative, because otherwise it crashes, if we are on a center subdomain
						fancyParams.width = 600;
						fancyParams.maxWidth = 600;
						fancyParams.autoSize = false;
						fancyParams.fitToView = false;
						fancyParams.height = 'auto'
						fancyParams.padding = 33

						$.fancybox.showLoading();

						$.get(url, function(data){
							var content = $('<div>' + data + '<div>');
							$.fancybox(content, fancyParams);
							LegacyWidgets.init(content);
						});

						return false;
					})

				} else {
					elem.fancybox(fancyParams);
				}


			}]
		, 'pagination' : [false, function(elem){

				var config = myEval(elem.data('config'))
				  , wrapper = elem.parent()

				  , pagesize = config.pagesize
				  , items = elem.children('.event-line')
				  , itemsCount = items.length

				  , pager = $('<div class="pager"></div>')
				  , pagingTemplate = '<button type="button" class="ev-page-prev">{0}</button> <button type="button" class="ev-page-next">{1}</button> <span class="pagecount">{2}</span>'

				  , Pager = function(el, config) {
						var currentpage
						  , pagesize = config.pagesize
						  , elem = el
						  , locationMap = {}
						  , locations = []
						  , events = el.find('.event-line')
						  , visibleEvents = events
						  , pageCount = 1
						  , prevBtns = el.find('.ev-page-prev')
						  , nextBtns = el.find('.ev-page-next')
						  , select = el.find('.es-cal-filter-select')
						  , frame = el.find('.es-calender')
						  , obj = this
						  , disable = function(btns) { btns.addClass('disabled'); }
						  , enable = function(btns) { btns.removeClass('disabled'); }
						  , counter = el.find('.ev-cpage-cntr')
						  , totalPageCounter = el.find('.ev-cpage-tntr')
						  , buildFilterMap = function(){
								var i, loc;

								events.each(function(){
									var el = $(this)
									  , loc = el.find('.ev-loc span[itemprop="name"]').html();

									if (locationMap[loc]) {
										locationMap[loc] = locationMap[loc].add(el);
									} else {
										locations[locations.length] = loc;
										locationMap[loc] = el;
									}

								});

								if (locations.length > 1) {
									select.append('<option value="">- ' + translate('caption.all') + ' -</option>');
									locations.sort(function(a,b){
										return a.toLowerCase() < b.toLowerCase() ? -1 : (a.toLowerCase() > b.toLowerCase() ? 1 : 0)});
								}

								for (i = 0; i < locations.length; i++) {
									loc = locations[i];
									select.append('<option value="' + loc + '">' + loc + ' (' + locationMap[loc].length + ')' + '</option>');
								}

								select.change({filter: obj}, function(e){
									e.data.filter.init($(this).val());
								});
						    }
						;

						this.init = function(filterVal){
							var i, p;

							visibleEvents = locationMap[filterVal] ? locationMap[filterVal] : events;
							pageCount = Math.ceil(visibleEvents.length / pagesize);
							totalPageCounter.html(pageCount);

							currentpage = 1;
							counter.html(currentpage);
							events.hide();
							visibleEvents.show();

							// elem.find('.es-calender').height(pages.slice(0,1).height() - 1);
							// pages.slice(currentpage, pages.length - currentpage).hide();
							disable(prevBtns);

							if (pageCount > 1) {
								enable(nextBtns);
							} else {
								disable(nextBtns);
							}
						}

						this.page = function(offset){
							var newPage = currentpage + offset;

							enable(nextBtns);
							enable(prevBtns);

							if (newPage >= pageCount) {
								disable(nextBtns);
								enable(prevBtns);
								newPage = pageCount;
							}

							if (newPage <= 1) {
								disable(prevBtns);
								enable(nextBtns);
								newPage = 1;
							}

							if (newPage != currentpage) {
								visibleEvents.hide();
								currentpage = newPage;
								visibleEvents.slice((currentpage - 1)* pagesize , currentpage * pagesize).show();
								counter.html(currentpage);
							}
						}

						buildFilterMap();
						nextBtns.bind('click', {pager: obj}, function(e){ e.data.pager.page(1); });
						prevBtns.bind('click', {pager: obj}, function(e){ e.data.pager.page(-1); });
						this.init('');
					}
				  , i
				;

				// initial pagination add
				if (itemsCount > config.pagesize) {

					wrapper.find('.es-calender').height(config.pagesize * 30)

					// add the pagination
					wrapper.append(pager.append(pagingTemplate.format(
						  translate('caption.previous.page')
						, translate('caption.next.page')
						, translateF('caption.pagination', '<span class="ev-cpage-cntr">1</span>', '<span class="ev-cpage-tntr">1</span>')
					)));
				} else {
					wrapper.find('.es-calender').height(itemsCount * 30)
				}

				if (config.filter) {
					wrapper.prepend('<div class="ev-cal-filter">Filter by City: <select class="es-cal-filter-select"></select></div>');
				}

				elem.data('pager', new Pager(wrapper, config));
			}]
		, 'ajax-menu' : [false, function(elem){

			PageHandle.registerAjaxMenu(elem);

		}]

		, 'ajax-links' : [false, function(elem){
			elem.find('a').each(function(){
				PageHandle.registerAjaxLink($(this));
			});
		}]

		, 'browsercheck' : [false, function(elem){
			if (elem.hasClass('ltIE8')) {
				elem.hide().html(translate('bad.ie.browser')).slideDown(600).animate({'left' : 0}, 6000, function(){$(this).slideUp(300)});
			}
		}]

		, 'facebook' : [false, function(elem){

			elem.html('');
			if (! includeScript( "//connect.facebook.net/" + PageHandle.getFacebookLocale() + "/all.js#xfbml=1" , 'facebook-jssdk')){
				try{ FB.XFBML.parse(); }catch(ex){} // simple rerender if the script is already included
			}
		}]

		, 'schematic-map' : [ false ,function(elem){
			elem.find('#esSchematicMapSelect').change(function() {
				var val = $(this).val();

				if (val != "default") {
					document.location.href = val;
				}

			});

			// handle the dots
			elem.find('.centerlink').each(function(){
				var elem = $(this), tooltip = $('<span class="tooltip">' + elem.attr('title') + '</span>').hide();
				elem.append(tooltip).data({tooltip: tooltip}).attr('title', '');
			}).on('mouseover', function(){
				fade($(this).data('tooltip'), 1, 50);
			}).on('mouseleave', function(){
				fade($(this).data('tooltip'), 0, 250);
			});
		}]

		, 'teaser' : [ 'teaser', function(elem){
			elem.teaser()
		}]

		, 'video' : ['videoinit', function(elem){}]

		, 'innerfade' : ['innerfade', function(elem){
			elem.innerfade(myEval(elem.data('config')));
		}]

		, 'gMaps' : ['gMaps', function(elem){
			elem.gMaps(myEval(elem.data('config')));
		}]

		, 'gMapsOverlay' : ['fancybox', function(elem){
			elem.fancybox({
				  maxWidth		: 800
				, maxHeight		: 600
				, fitToView		: false
				, width			: '70%'
				, height		: 600
				, autoSize		: false
				, closeClick	: false
			});
		  }]

		, 'image-gallery' : ['fancybox', function(elem){
			elem.find('a.trigger-gal').fancybox({
				  maxWidth		: '90%'
				, maxHeight		: 600
				, fitToView		: false
				, width			: '70%'
				, height		: '70%'
				, autoSize		: false
				, nextEffect 	: 'fade'
				, prevEffect 	: 'fade'
			});
		  }]
	}

	, registeredFinalls : {
		'scale-img' : function(){
			ImageScaler.addImages(LegacyWidgets.vars.images);
			LegacyWidgets.vars.images = null;
		}
	  }

	// to register a new widget dynamically
	// @param Number Priority			- an optional priority in order to have controll, which widget is executed first
	, register : function(id, func, script, priority) {
		var scriptVar = (script === undefined) ? false : script;
		if (this.registered[id]) debug("[WARNING] Widget " + id + " was already registered: Override.");
		this.registered[id] = [scriptVar, func, priority];
	}

	, init : function(root) {
		var priorityList = []
		  , wdgArrays = {}
		  , wdg, i, k, cList, allWidgets = []
		;

		for (wdg in this.registered) {
			priorityList[priorityList.length] = [wdg, this.registered[wdg][2]]; // 2 is the priority
			wdgArrays[wdg] = [];
		}

		priorityList.sort(function(a, b){
			if (a[1] !== undefined && b[1] == undefined) return -1;
			if (a[1] == undefined && b[1] !== undefined) return 1;
			return a[1] < b[1] ? 1 : (a[1] > b[1]) ? -1 : 0;
		});

		// get all the elements of the type widget
		root.find('.' + this.widgetClass).each(function(){
			var elem = $(this)
			  , names = elem.data('widgetname').split(' ')
			  , name
			  , i
			;

			for (i in names) {
				name = names[i];
				if (wdgArrays[name] !== undefined) {
					wdgArrays[name].push(elem);
				} else {
					debug("No method for widget " + name + " provided");
				}
			}
		});
		//  and initialise them according to the priority
		for (i = 0; i < priorityList.length; i++) {
			wdg = priorityList[i][0];
			cList = wdgArrays[wdg];
			if (cList.length) {
				for (k = 0; k < cList.length; k++) {
					allWidgets[allWidgets.length] = cList[k];
					LegacyWidgets.initSpecific(cList[k], wdg);
				}

				if (this.registeredFinalls[wdg]) this.registeredFinalls[wdg]();
			}
			delete wdgArrays[wdg]; // remove the initialized array, in order to check, if something was not initialized
		}

		// delete the widget class later in case of multi widgets
		for (k in allWidgets) {
			allWidgets[k].removeClass(this.widgetClass); // remove the class to prevent a second initialization
		}
	}

		// @param Boolean force 		- allows to initialize a widget also, if it was already initialized
	, initSpecific : function(elem, widgetname, force){

		try {
			if (elem.hasClass(this.widgetClass) || force){ // just in case something has changed meanwhile...

				// now check, if we need a script
				if (this.registered[widgetname][0]) {

					var eventName = this.scriptClass + '-' + this.registered[widgetname][0];

					includeScript(this.scripts[this.registered[widgetname][0]], eventName, elem.bind(eventName, function(event){
						event.stopPropagation(); // avoid event from bubbling up.
						// debug(eventName + ' was triggered');
						LegacyWidgets.registered[widgetname][1](elem);
						elem.addClass(this.widgetClass + '-initialized');
					}))
				} else {
					this.registered[widgetname][1](elem);
					elem.addClass(this.widgetClass + '-initialized');
				}
			}
		} catch (e) {
			debug("Error during execution of widget " + widgetname + ": " + e.message);
			elem.addClass(this.widgetClass + '-error');
			return false;
		}

		return true;
	}
}
*/

// Encapsules functionality needed for the Page reload logic on hash base
var PageHandle = {
  urlPageLoadHashSign: ['|', ':-)'], // Do not change this sign - after going life - without providing a legacy mechanism. Otherwise all the urls out there, will be lost
  currentReloadURL: '',
  currentURL: null,
  browser: { type: null, version: null },
  mode: 'ajax',
  ajaxMenus: {}, // this will hold all the menus, with theire id as key
  urlMenuLinkElements: {}, // holds all the potential elements pointing to the same url - url-string : [Element 1, Element 2]
  targeting: { // this can be overritten to adapt the update process to the need of your site
    mainRegex: /<div id="main".*?>/,
    mainSelector: '#main',
    headercontainerSelector: '#headercontainer',
  },
  callbacks: { // cllbacks can be used to adapt the ajaxmenu to the needs of your site
    'beforeUpdateMain': {},
    'afterMainReplace': {
      'default': function (main) {
        main.find('.esSchematicMap').remove();
      },
    },
    'afterUpdateMain': {},
  },
  registerAjaxMenu: function (ajaxMenuElem) {
    var id = ajaxMenuElem.identify('es-am').attr('id'),
      config = myEval(ajaxMenuElem.data('config')),
      forceInternal = config && config.forceInternal ? true : false, // in order to have a tool, to override the multi side beahviour
      obj = this;
    this.ajaxMenus[id] = ajaxMenuElem;

    ajaxMenuElem.addClass('ajax-menu').find('.trigger-ajax-menu').each(
      function () {
        var el = $(this),
          href = el.attr('href'),
          url = (new URL(href)).makeRelative();

        if (obj.urlMenuLinkElements[url.toString()]) {
          obj.urlMenuLinkElements[url.toString()].add(el);
        } else {
          obj.urlMenuLinkElements[url.toString()] = el;
        }

        PageHandle.registerAjaxLink(el, forceInternal);
      },
    );

    // update the menu selection
    this.updateAjaxMenus();
  },
  registerAjaxLink: function (linkTag, forceInternal) {
    if (linkTag.attr('href')) {
      var url = new URL(linkTag.attr('href'));

      if (
        !linkTag.hasClass('no-ajax') && !linkTag.data('ajax') &&
        (forceInternal || url.isInternalURL()) && url.isWebPage()
      ) {
        linkTag.data('ajax', true).bind('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var el = $(this),
            url = (new URL(el.attr('href'))).makeRelative();

          if (DWBF_MOBILE) {
            $('#navigation_visible').parent().animate({ left: '-70%' }, 280);
          }

          PageHandle.updateMain(url);
          return false;
        });
      }
    }
  },
  registerCallback: function (callbackID, callback, callbackName) {
    this.callbacks[callbackID][callbackName] = callback;
  },
  removeCallback: function (callbackID, callbackName) {
    delete this.callbacks[callbackID][callbackName];
  },
  executeCallback: function () {
    var callbackID = arguments[0];
    if (this.callbacks[callbackID]) {
      for (name in this.callbacks[callbackID]) {
        switch (arguments.length) {
          default:
            this.callbacks[callbackID][name]();
            break;
          case 2:
            this.callbacks[callbackID][name](arguments[1]);
            break;
          case 3:
            this.callbacks[callbackID][name](arguments[1], arguments[2]);
            break;
        }
      }
    }
  },
  init: function () {
    var pHandle = this;

    this.currentURL = new URL();

    if ($('.ltIE8').length) {
      this.browser.type = 'IE';
      this.browser.version = '<8';
    } else if ($('.IE8').length) {
      this.browser.type = 'IE';
      this.browser.version = '8';
    }

    $(window).bind('popstate', function (e) { // this is thrown, when the user clicks on history back wich was passed via window.history.pushState
      debug(window.location.href);
      pHandle.updateMain(new URL(window.location.href), true);
    });
  },
  setMode: function (mode) {
    this.mode = mode;
    debug('PageHandle now in mode ' + mode);
  },
  setTargeting: function (targetingObj) {
    if (targetingObj && typeof targetingObj == 'object') {
      this.targeting = targetingObj;
    }
  },
  getFacebookLocale: function () {
    var loc = i18n.locales[0], // locales from the i18n.js
      FBLocales = {
        'de': 'de_DE',
        'fr': 'fr_FR',
        'es': 'es_ES',
        'en': 'en_GB',
        'ru': 'ru_RU',
        'nl': 'nl_NL',
        'pt': 'pt_PT',
        'it': 'it_IT',
      };

    return (FBLocales[loc]) ? FBLocales[loc] : FBLocales[i18n.defaultLocale];
  },
  testHashState: function () {
    var url = this.getCurrentHashURL();

    if (url) {
      // this is a hash url, do a reload
      this.updateMain(url, true);
    }
  },
  getCurrentHashURL: function () {
    var hash = window.location.hash.replace('#', ''),
      len,
      i;

    for (i = 0; i < this.urlPageLoadHashSign.length; i++) {
      len = this.urlPageLoadHashSign[i].length;
      if (hash.substr(0, len) == this.urlPageLoadHashSign[i]) {
        return new URL(hash.substr(len));
      }
    }

    return null;
  },
  updateAjaxMenus: function () {
    // check the menu
    var cHashUrl = this.currentURL.clone(),
      esAmId,
      elem;

    if (cHashUrl) {
      cHashUrl = cHashUrl.makeRelative().toString();
      for (esAmId in this.ajaxMenus) {
        elem = this.ajaxMenus[esAmId];
        elem.find('.current').removeClass('current');

        elem.find('a').each(function () {
          var el = $(this),
            href = el.attr('href');

          if (href && (new URL(href)).makeRelative().toString() == cHashUrl) {
            el.parents('.ajax-menu li').addClass('current');
          }
          return true;
        });
      }
    }
  },
  updateMain: function (url, noHistory) {
    var urlString = url.toString();

    if (
      urlString != this.currentReloadURL &&
      url.pathname != this.currentURL.pathname
    ) {
      this.executeCallback('beforeUpdateMain');

      var main = $(this.targeting.mainSelector),
        mainParent = main.parent(),
        overlay = mainParent.children('.layer').length
          ? mainParent.children('.layer')
          : $('<div class="layer ajaxloader-white"></div>').hide();

      this.currentReloadURL = urlString;
      this.currentURL = url.clone();

      if (!mainParent.children('.layer').length) mainParent.append(overlay);
      fade(overlay, 1, 210);

      if (this.mode != 'ajax') {
        window.location.href = this.currentReloadURL;
      } else {
        if (window.history && window.history.pushState) {
          if (!noHistory) window.history.pushState(null, '', urlString);
        } else {
          window.location.hash = this.urlPageLoadHashSign[0] + urlString;
        }

        this.updateAjaxMenus(); // update the menu selection

        url.addParameter('format', 'ajax-main');
        $.ajax({
          url: url.toString(),
          success: function (data) {
            var split = data.search(PageHandle.targeting.mainRegex),
              head = $('<div>' + $.trim(data.substr(0, split)) + '</div>'),
              body = data.substr(split),
              headercontainer = $(PageHandle.targeting.headercontainerSelector),
              title;

            PageHandle.currentReloadURL = ''; // reset the reload url

            try {
              if (headercontainer.length && head.length) {
                headercontainer.replaceWith(
                  head.find(PageHandle.targeting.headercontainerSelector),
                );
              }
              main.replaceWith(body);
            } catch (e) {
              debug(
                '[Error] PageHandle.updateMain: Included HTML threw js error: ' +
                  e.message,
              );
            }

            main = $(PageHandle.targeting.mainSelector);

            PageHandle.executeCallback('afterMainReplace', main);

            title = main.find('#ajax_title').val();
            if (title) $('title').html(title);

            // initialise all the widgets
            Widgets.init(main.get(0));
            Widgets.init(
              $(PageHandle.targeting.headercontainerSelector).get(0),
            );

            PageHandle.executeCallback('afterUpdateMain');

            fade(overlay, 0, 420, null, 120);

            // if we have a hash, set it explicitly in order to keep # url functionality
            if (url.hash) window.location.hash = url.hash;
          },
          error: function () {
            main.find('.layer').remove();
          },
        });
      }
    }
  },
  resolveURL: function (urlString) {
    return /opencms\//gi.test(location.pathname)
      ? '/opencms/' + urlString
      : urlString;
  },
};

// Identify jQuery plugin
jQuery.fn.identify = function (prefix) {
  var i = 0;
  return this.each(function () {
    if ($(this).attr('id')) return;
    do {
      i++;
      var id = prefix + '_' + i;
    } while ($('#' + id).length > 0);
    $(this).attr('id', id);
  });
};

//--------- Debugging functions to wrap the firebug -------------------
function d(val) {
  debug(val);
}
function debug() {
  if (typeof console != 'undefined') {
    switch (arguments.length) {
      case 1:
        console.log(arguments[0]);
        break;
      case 2:
        console.log(arguments[0], arguments[1]);
        break;
      case 3:
        console.log(arguments[0], arguments[1], arguments[2]);
        break;
      case 4:
        console.log(arguments[0], arguments[1], arguments[2], arguments[3]);
        break;
    }
  }
}

function trace() {
  if (typeof console != 'undefined') {
    console.trace();
  }
}

// function to asyncronously include a script. If the script is already there, an event with the scritp id is triggered
function includeScript(url, id, elem) {
  var script = jQuery('#' + id),
    loadCallback = function () {
      if (elem) elem.trigger(id);
    };

  if (!id) debug('[WARNING] no unique id for includeScript() given');

  if (script.length && elem) {
    if (script.data('loaded') == true) {
      debug(id + ' triggered on element %o. [after load]', elem);
      if (elem) elem.trigger(id);
    } else {
      // use the document IE 8 does not trigger load event on scripts
      $('body').bind(id, loadCallback);
    }
    return false;
  }

  // trigger the event also on the specific elem, if the script was loaded
  $('body').bind(id, loadCallback);

  script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = PageHandle.resolveURL(url);
  script.id = id;
  script.async = 'async';
  // trigger this event on document, if the script was loaded.

  if (
    PageHandle.browser.type == 'IE' &&
    (PageHandle.browser.version == '<8' || PageHandle.browser.version == '8')
  ) {
    script.onreadystatechange = function () {
      if (
        !$(this).data('loaded') &&
        (this.readyState == 'loaded' || this.readyState == 'complete' ||
          this.readyState == 'interactive')
      ) {
        $(this).data('loaded', true);
        $('body').trigger(id);
      }
    };
  } else {
    script.onload = function () {
      $(this).data('loaded', true);
      $('body').trigger(id);
    };
  }

  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(script, s);
  return true;
}

// eval function, which is not messing up the minification
function myEval(evalcode) {
  return eval('(' + evalcode + ')');
}

// format function for a primitive template engine
if (!String.prototype.format) {
  String.prototype.format = function () {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] != 'undefined' ? args[number] : match;
    });
  };
}

// --------- Fixed Fade Function ------------------------

function fade(element, opacity, duration, cbFunction, retension) {
  var callback = null;

  switch (opacity) {
    default:
      callback = function () {
        // user defined callback
        if (cbFunction) cbFunction($(this));
      };
      break;
    case 0:
      callback = function () {
        $(this).css('display', 'none');

        // user defined callback
        if (cbFunction) cbFunction($(this));
      };
      break;
    case 1:
      callback = function () {
        // fallback for ie to remove the filter.
        if ($('#browser-IE').length) {
          $(this).css('filter', '').attr(
            'style',
            $(this).attr('style').replace('filter:', ''),
          );
        }

        // user defined callback
        if (cbFunction) cbFunction($(this));
      };
      break;
  }

  element.stop(true);

  var opac = element.css('display') == 'none' ? 0 : element.css('opacity');
  element.css({ 'display': 'block', 'opacity': opac });
  if (retension) {
    element.animate({ 'opacity': opac }, retension, function () {
      element.animate({ 'opacity': opacity }, duration, callback);
    });
  } else {
    element.animate({ 'opacity': opacity }, duration, callback);
  }
}

// The Url class
// if it is initialised without an url parameter, it will take the current URL
var URL = function (url) {
  if (!url) url = location.href;
  url = url.replace(/\+/gi, ' '); // replace + with a ' '

  this.parameters = {};
  this.baseURL = url;

  // get the hash
  var split = url.split('#');
  this.hash = (split.length > 1) ? split[1] : null;

  // get the body
  var split = split[0].split('?');
  this.urlBody = split[0];

  // split the parameters
  if (split.length > 1) {
    var params = split[1].split('&');
    var cLen = params.length;
    for (var cnt = 0; cLen--; cnt++) {
      var cStr = new String(params[cnt]).split('=');
      this.parameters[cStr[0]] = decodeURIComponent(cStr[1]);
    }
  }

  split = this.urlBody.split('/');
  this.isRelative = split[0].substr(0, 4) != 'http';

  this.protocol = this.isRelative ? window.location.protocol : split.shift();
  if (!this.isRelative) split.shift(); // getting ri of the empty entry in the array
  this.host = this.isRelative ? window.location.host : split.shift();
  this.pathname = split.join('/');
  if (!this.pathname.substr(0, 1) == '/') this.pathname = '/' + this.pathname;

  this.setHash = function (newHash) {
    this.hash = newHash;
    return this;
  };
  this.getHash = function () {
    return this.hash;
  };

  this.hasParameters = function () {
    var p;
    for (p in this.parameters) {
      if (p) return true;
    }
    return false;
  };

  this.hasParameter = function (pName) {
    return (this.parameters[pName]) ? true : false;
  };

  this.getParameter = function (pName) {
    return this.parameters[pName];
  };

  this.addParameter = function (name, value) {
    if (name && value) {
      this.parameters[name] = value;
    }
    return this;
  };

  this.addParameters = function (parameterMap) {
    for (param in parameterMap) {
      this.addParameter(param, parameterMap[param]);
    }
    return this;
  };

  this.removeParameter = function (name) {
    delete this.parameters[name];
    return this;
  };

  this.makeRelative = function () { // throws away the host and the protocoll and also index.html, if it is in the end
    if (this.urlBody.substr(0, 4) == 'http') {
      this.urlBody = this.urlBody.replace(/^(?:\/\/|[^\/]+)*\//, '/');
    }

    this.urlBody = this.urlBody.replace('index.html', ''); // remove the index.html, because it should never appear in the menu bar
    // this.hash = null;

    return this;
  };

  this.isInternalURL = function () {
    return window.location.host == this.host;
  };

  this.isWebPage = function () {
    var parts = this.pathname.split('.');
    return parts.length > 1
      ? $.inArray(parts.pop(), ['html', 'htm', 'php', 'jsp', '']) > -1
      : true;
  };

  this.clone = function () {
    return new URL(this.toString());
  };

  // Creates a proper URL String expression of this object
  //
  //@param excludeHash : Boolean		Weather the Hash should be part of the url string or not
  this.toString = function (excludeHash) {
    var url = this.urlBody;

    if (this.hasParameters()) {
      var first = true;
      var p;
      for (p in this.parameters) {
        url += first ? '?' : '&';
        url += p + '=' + encodeURIComponent(this.parameters[p]);
        first = false;
      }
    }

    if (!excludeHash && this.hash) {
      url += '#' + this.hash;
    }

    return url;
  };
};

// Image Scaler inspired strongly by Foresight.js 2.0.0 Copyright (c) 2012, Adam Bradley
// Available via the MIT license. See: https://github.com/adamdbradley/foresight.js
//
// window and document are already jQuery objects
// requires url class
var ImageScaler = {};
(function (ImageScaler, window, document, navigator) {
  var imageList = [],
    scalingImageList = [],
    scalerURL =
      'https://assets.dwbn.org/scale/public/%w%x%h%/www.buddhism-foundation.org',
    scaleStepsPx = 50, // Server side Restriction of Image Scaling
    scaleStepExceptions = [647, 984], // Exceptions of the Serverside scale normalization in order to get a perfect result for common formats
    lastChangedAt, // a timestamp, which will be used, to reduce calculations for single images
    reloadTimeoutId,
    IMG_STATUS_IGNORE = 'ignore',
    IMG_STATUS_ERROR = 'hasError',
    IMG_STATUS_INITIALIZED = 'initialized',
    DEFAULT_SRC = 'defaultSrc',
    DIMENSION_WIDTH = 'width',
    DIMENSION_HEIGHT = 'height',
    WIDTH_UNITS = 'widthUnits',
    HEIGHT_UNITS = 'heightUnits',
    ASPECT_RATIO_CALCULATED = 'aspect-calc',
    ASPECT_RATIO = 'aspect-ratio',
    ASPECT_RATIO_AUTO = 'auto',
    SRC_MODIFICATION = 'srcModification',
    BROWSER_WIDTH = 'browserWidth',
    BROWSER_HEIGHT = 'browserHeight',
    CHANGED_AT = 'changedAT',
    TRUE = true,
    FALSE = false,
    urlCache = {
      urls: {},
      images: {},
      registerImage: function (url, img) {
        if (url) {
          if (this.get(url) !== true) {
            img.attr('src', this.get(url));
          } else {
            if (!this.images[url]) this.images[url] = [];
            this.images[url].push(img);
          }
        }
      },
      getLocalUrl: function (url) {
        if (window.devicePixelRatio > 1) {
          url = PageContext.bandwidth + ':' + url;
        }

        return url;
      },
      processImages: function (pArr) {
        var i, url, img, callArr = [], callData = [], cache = this;

        for (i = 0; i < pArr.length; i++) {
          if (!cache.get(pArr[i][1])) {
            callArr.push(pArr[i]);
            callData.push(pArr[i][1]);
          } else {
            cache.registerImage(pArr[i][1], pArr[i][0]);
          }
        }

        // now we make the actual call
        if (callArr.length) {
          var data = '';
          callData.forEach(function (im, index) {
            var parts = im.split('*');
            if (data) {
              data += '|';
            }
            var url = scalerURL.replace('%w%', '').replace('%h%', parts[2]) +
              parts[0];
            data += '<img src="' + url + '" width="' + parts[1] + '" height="' +
              parts[2] + '" />';
          });

          var imgs = data.split('|'),
            split,
            foundSrc,
            i;

          for (i = 0; i < imgs.length; i++) {
            url = callArr[i][1];
            img = callArr[i][0];
            split = imgs[i].split('src="');
            foundSrc = (split.length > 1)
              ? split[1].split('"')[0]
              : img[0][DEFAULT_SRC];

            // Check if we don't have the error page image
            if (foundSrc == '/system/workplace/resources/commons/error.png') {
              debug('WARNING: Image Scaler returned Error');
              foundSrc = img[0][DEFAULT_SRC];
            }

            cache.urls[url] = foundSrc;

            if (PageContext.hasLocalStorage()) {
              localStorage.setItem(cache.getLocalUrl(url), foundSrc); // adding the image to the localStorage also
            }
          }
          for (var i = 0; i < callArr.length; i++) {
            url = callArr[i][1];
            img = callArr[i][0];
            img.attr('src', cache.urls[url]);
            if (cache.images[url] && cache.images[url].length) {
              for (var i = 0; i < cache.images[url].length; i++) {
                cache.images[url][i].attr('src', cache.urls[url]);
              }
              cache.images[url] = [];
            }
          }
        }
      },
      get: function (url) {
        if (!this.urls[url]) {
          // try the local storage
          var lImgUrl = localStorage.getItem(this.getLocalUrl(url));
          if (lImgUrl) {
            // debug('LocalStorage Hit: ' + lImgUrl);
            this.urls[url] = lImgUrl;
          }
        }

        return this.urls[url];
      },
    },
    addWindowResizeEvent = function () {
      window.resize(function () {
        // there are horizontal rezise events, which could change the width, so we call it always.
        lastChangedAt = (new Date()).getTime();
        ImageScaler.reload();
      });
    },
    initNewImages = function () {
      var x, img, rawImg, rebuildImages = [];

      for (x = 0; x < imageList.length; x++) {
        img = imageList[x];
        rawImg = img[0];

        // if we've already said to ignore this img then don't bother doing any more
        if (rawImg[IMG_STATUS_IGNORE]) continue;

        // initialize properties the image will use
        // only gather the images that haven't already been initialized
        if (!rawImg[IMG_STATUS_INITIALIZED]) {
          rawImg[IMG_STATUS_INITIALIZED] = TRUE;
          rawImg[DEFAULT_SRC] = img.data('src'); // important, do not set the src attribute yet!

          // always set the img's data-width & data-height attributes so we always know its aspect ratio
          rawImg[WIDTH_UNITS] = img.data(DIMENSION_WIDTH);
          rawImg[HEIGHT_UNITS] = img.data(DIMENSION_HEIGHT);

          rawImg[ASPECT_RATIO_CALCULATED] = rawImg[WIDTH_UNITS] /
            rawImg[HEIGHT_UNITS];

          // if the aspect ratio was set then let's use that
          var tmpAspectRatio = img.data(ASPECT_RATIO);
          rawImg[ASPECT_RATIO] = tmpAspectRatio === ASPECT_RATIO_AUTO
            ? tmpAspectRatio
            : (!isNaN(tmpAspectRatio) && tmpAspectRatio !== null
              ? parseFloat(tmpAspectRatio)
              : 0);

          // missing required info
          if (
            !rawImg[DEFAULT_SRC] ||
            ((!rawImg[WIDTH_UNITS] || !rawImg[HEIGHT_UNITS]) &&
              !rawImg[ASPECT_RATIO])
          ) {
            debug('ignore because of missing data');
            rawImg[IMG_STATUS_IGNORE] = TRUE;
            continue;
          }

          // handle any response errors which may happen with this image
          rawImg.onerror = imgResponseError;

          // add this image to the collection
          scalingImageList.push(img);
        } else {
          // if we reached the already initialized images, we stop the loop
          break;
        }

        rebuildImages.push(img);
      }

      imageRebuild(rebuildImages);
    },
    imageRebuild = function (imgArray) {
      var rawImg, img, img_src, url, x, srcArray = [];

      for (x = 0; x < imgArray.length; x++) {
        img = imgArray[x];
        rawImg = img[0];

        if (!isParentVisible(img) || rawImg.ignore) {
          // parent element is not visible (yet anyways) so don't continue with this img
          continue;
        }

        img_src = rawImg[DEFAULT_SRC] ? rawImg[DEFAULT_SRC] : img.attr('src');

        // get the computed pixel width according to the browser
        fillComputedPixelDimensions(img);

        // now we build the src attribute
        // url = scalerURL.addParameters({'src': img_src.urlBody, 'width' : rawImg[ BROWSER_WIDTH ], 'height': rawImg[ BROWSER_HEIGHT ]}).toString();
        img_src = img_src + '*' + rawImg[BROWSER_WIDTH] + '*' +
          rawImg[BROWSER_HEIGHT];
        srcArray.push([img, img_src]);

        rawImg[CHANGED_AT] = (new Date()).getTime(); // set the changed time stamp
      }

      urlCache.processImages(srcArray);
      return TRUE;
    },
    fillComputedPixelDimensions = function (img) {
      var rawImg = img[0],
        width = img.width(),
        height = img.height(),
        ratio = img.data('width') / img.data('height');

      // the computed width is probably getting controlled by some applied width property CSS
      // since we now know what the pixel wi dth the browser wants it to be, calculate its height
      // the height should be calculated with the correct aspect ratio
      // this should be re-ran every time the window width changes
      rawImg[BROWSER_WIDTH] = getNormalizedWidth(
        width > 0 ? width : height * rawImg[ASPECT_RATIO_CALCULATED],
      ); // if we don't have a width, we are using the calculated with from the height
      rawImg[BROWSER_HEIGHT] = Math.round(rawImg[BROWSER_WIDTH] / ratio);

      // set placeholder css in order to have a initial box for correct height and with display
      img.css({
        DIMENSION_WIDTH: rawImg[BROWSER_WIDTH],
        DIMENSION_HEIGHT: rawImg[BROWSER_HEIGHT],
      });
      if (!img.hasClass('loaded') && img.attr('src')) {
        img.on('load', function () {
          $(this).css({ 'width': '', 'height': '' }).unbind('load').addClass(
            'loaded',
          );
        });
      }
    },
    getNormalizedWidth = function (width) {
      if (scaleStepExceptions.indexOf(width) == -1) {
        var scaleStepRatio = width / scaleStepsPx,
          intScaleStepRatio = parseInt(scaleStepRatio);
        width = intScaleStepRatio * scaleStepsPx;
        if (
          scaleStepRatio > intScaleStepRatio && PageContext.isHighBandwidth()
        ) width += scaleStepsPx; // upscale on high connections for better quality if there is a benefit
      }
      return width;
    },
    imgResponseError = function (img) {
      var rawImg = this;
      img = $(rawImg);
      rawImg[SRC_MODIFICATION] = 'response-error';
      if (rawImg[IMG_STATUS_ERROR] || img.attr('src') === rawImg[DEFAULT_SRC]) {
        return;
      }
      rawImg[IMG_STATUS_ERROR] = TRUE;
      img.attr('src', rawImg[DEFAULT_SRC]);
    },
    isParentVisible = function (ele, parent) {
      // test to see if this element's parent is currently visible in the DOM
      parent = ele.parent();
      if (parent.is(':visible') && parent.width()) {
        return TRUE;
      }
      if (parent.css('display') === 'inline') {
        // if its parent is an inline element then we won't get a good clientWidth
        // so try again with this element's parent
        return isParentVisible(parent);
      }
      return FALSE;
    },
    executeReload = function () {
      if (!PageContext.complete()) return; // dont reload, if we don't have a speedtest connection result jet
      imageRebuild(scalingImageList);
    };

  ImageScaler.initNew = function () {
    if (PageContext.complete()) {
      initNewImages();
    } else {
      setTimeout(ImageScaler.initNew, 1);
    }
  };

  // needs data-height, data-width, ddta-aspect-ratio=auto and data-src . class="fs-img"
  ImageScaler.addImage = function (fsImage) {
    if (fsImage) imageList.unshift(fsImage); // add new images at first position of the array
    ImageScaler.initNew();
  };

  ImageScaler.addImages = function (fsImages) {
    if (fsImages) {
      for (var i = 0; i < fsImages.length; i++) {
        imageList.unshift($(fsImages[i]));
      }
    }
    ImageScaler.initNew();
  };

  ImageScaler.reload = function () {
    // avoid to overdo it...
    window[0].clearTimeout(reloadTimeoutId);
    reloadTimeoutId = window[0].setTimeout(executeReload, 250);
  };

  ImageScaler.recheckImage = function (img) {
    var rawImg = img[0];
    if (!rawImg[CHANGED_AT] || rawImg[CHANGED_AT] < lastChangedAt) {
      imageRebuild([img]);
    }
  };

  ImageScaler.debug = function () {
    debug(imageList);
    debug('lastChangedAt: ' + lastChangedAt);
    debug(urlCache);
  };

  addWindowResizeEvent();
})(ImageScaler, $(this), $(document), navigator);

//The bandwidth and connection speed test in this script is inspired by and based on foresight.js
//Available via the MIT license.
//For details see: https://github.com/adamdbradley/foresight.js
//
//We tryed to keep this file as small as possible in order to start with the speedtest as fast as possible - This file does not depend on anything

//Defining the PageContext - this holds all the relevant Information, of the page
var PageContext = {};
(function pageContext(PageContext, navigator, document, window) {
  PageContext.options = PageContext.options || {};

  var opts = PageContext.options,
    e = document.documentElement,
    g = document.getElementsByTagName('body')[0],
    VIEWPORT_X = window.innerWidth || e.clientWidth || g.clientWidth,
    VIEWPORT_Y = window.innerHeight || e.clientHeight || g.clientHeight,
    MobileViewportBorderX = 750,
    speedTestUri = '/buddhism-foundation/img/50K.jpg', // we use no protocol but // in order to avoid security warning from https servers
    speedTestKB = 50, // The actual Size of the File
    minKbpsForHighBandwidth = opts.minKbpsForHighBandwidth || 300,
    speedConnectionStatus,
    speedTestTimeoutMS,
    speedTestExpireMinutes = opts.speedTestExpireMinutes || 30,
    connection = navigator.connection || { type: 'unknown' }, // polyfill
    BANDWIDTH = 'bandwidth',
    IS_MOBILE_DEVICE = 'isMobile',
    CONNECTION_TYPE = 'connType',
    CONNECTION_TEST_RESULT = 'connTestResult',
    CONNECTION_KBPS = 'connKbps',
    STATUS_LOADING = 'loading',
    STATUS_COMPLETE = 'complete',
    LOCAL_STORAGE_KEY = 'fsjs',
    LOCAL_STORAGE_AVAILABLE = null,
    IS_TOUCH_DEVICE = 'ontouchstart' in window || 'onmsgesturechange' in window,
    BANDWIDTH_HIGH = 'high',
    BANDWIDTH_LOW = 'low',
    TRUE = true,
    FALSE = false,
    initSpeedTest = function () {
      // only check the connection speed once, if there is a status then we've
      // already got info or it already started
      if (speedConnectionStatus) return;

      // force that this device has a low or high bandwidth, used more so for debugging purposes
      if (opts.forcedBandwidth) {
        PageContext[BANDWIDTH] = opts.forcedBandwidth;
        PageContext[CONNECTION_TEST_RESULT] = 'forced';
        speedConnectionStatus = STATUS_COMPLETE;
        return;
      }

      // if we know the connection is 2g or 3g
      // don't even bother with the speed test, cuz its slow
      // Network connection feature detection referenced from Modernizr
      // Modernizr v2.5.3, www.modernizr.com
      // Copyright (c) Faruk Ates, Paul Irish, Alex Sexton
      // Available under the BSD and MIT licenses: www.modernizr.com/license/
      // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/network-connection.js
      // Modified by Adam Bradley for Foresight.js
      var isSlowConnection = connection.type == 3 || // connection.CELL_2G
        connection.type == 4 || // connection.CELL_3G
        /^[23]g$/.test(connection.type); // string value in new spec
      PageContext[CONNECTION_TYPE] = connection.type;
      if (isSlowConnection) {
        // we know this connection is slow, don't bother even doing a speed test
        PageContext[CONNECTION_TEST_RESULT] = 'connTypeSlow';
        speedConnectionStatus = STATUS_COMPLETE;
        return;
      }

      // check if a speed test has recently been completed and its
      // results are saved in the local storage
      try {
        var fsData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
        if (fsData !== null) {
          if ((new Date()).getTime() < fsData.exp) {
            // already have connection data within our desired timeframe
            // use this recent data instead of starting another test
            PageContext[BANDWIDTH] = fsData.bw;
            PageContext[CONNECTION_KBPS] = fsData.kbps;
            PageContext[CONNECTION_TEST_RESULT] = 'localStorage';
            speedConnectionStatus = STATUS_COMPLETE;
            return;
          }
        }
      } catch (e) {}

      var speedTestImg = document.createElement('img'),
        endTime,
        startTime,
        speedTestTimeoutMS;

      speedTestImg.onload = function () {
        // speed test image download completed
        // figure out how long it took and an estimated connection speed
        endTime = (new Date()).getTime();

        var duration = (endTime - startTime) / 1000;
        duration = duration > 1 ? duration : 1; // just to ensure we don't divide by 0

        PageContext[CONNECTION_KBPS] = ((speedTestKB * 1024 * 8) / duration) /
          1024;
        PageContext[BANDWIDTH] =
          PageContext[CONNECTION_KBPS] >= minKbpsForHighBandwidth
            ? BANDWIDTH_HIGH
            : BANDWIDTH_LOW;

        speedTestComplete('networkSuccess');
      };

      speedTestImg.onerror = function () {
        // fallback incase there was an error downloading the speed test image
        speedTestComplete('networkError', 5);
      };

      speedTestImg.onabort = function () {
        // fallback incase there was an abort during the speed test image
        speedTestComplete('networkAbort', 5);
      };

      // begin the network connection speed test image download
      startTime = (new Date()).getTime();
      speedConnectionStatus = STATUS_LOADING;
      speedTestImg.src = speedTestUri + '?r=' + Math.random();

      // calculate the maximum number of milliseconds it 'should' take to download an XX Kbps file
      // set a timeout so that if the speed test download takes too long
      // than it isn't a 'high-bandwidth' and ignore what the test image .onload has to say
      // this is used so we don't wait too long on a speed test response
      // Adding 350ms to account for TCP slow start, quickAndDirty === TRUE
      speedTestTimeoutMS =
        (((speedTestKB * 8) / minKbpsForHighBandwidth) * 1000) + 350;
      setTimeout(function () {
        PageContext[BANDWIDTH] = BANDWIDTH_LOW;
        speedTestComplete('networkSlow');
      }, speedTestTimeoutMS);
    },
    speedTestComplete = function (connTestResult, expireMinutes) {
      // if we haven't already gotten a speed connection status then save the info
      if (speedConnectionStatus === STATUS_COMPLETE) return;

      // first one with an answer wins
      speedConnectionStatus = STATUS_COMPLETE;
      PageContext[CONNECTION_TEST_RESULT] = connTestResult;

      try {
        if (!expireMinutes) {
          expireMinutes = speedTestExpireMinutes;
        }
        var fsDataToSet = {
          kbps: PageContext[CONNECTION_KBPS],
          bw: PageContext[BANDWIDTH],
          exp: (new Date()).getTime() + (expireMinutes * 60000),
        };
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(fsDataToSet));
      } catch (e) {}
    },
    testLocalStorage = function () {
      try {
        localStorage.setItem('karmapa', 'tchenno');
        localStorage.removeItem('karmapa');
        LOCAL_STORAGE_AVAILABLE = 'localStorage' in window &&
          window['localStorage'] !== null;
      } catch (e) {
        LOCAL_STORAGE_AVAILABLE = false;
      }
    };

  // Public Functions
  PageContext.isHighBandwidth = function () {
    return PageContext[BANDWIDTH] == BANDWIDTH_HIGH;
  };
  PageContext.complete = function () {
    return speedConnectionStatus == STATUS_COMPLETE;
  };
  PageContext.isMobileDevice = function () {
    return PageContext[IS_MOBILE_DEVICE];
  };
  PageContext.isTouchDevice = function () {
    return IS_TOUCH_DEVICE;
  };

  PageContext.user = { loggedIn: false };

  PageContext.hasLocalStorage = function () {
    return LOCAL_STORAGE_AVAILABLE;
  };

  PageContext.debug = function () {
    debug(CONNECTION_TYPE + ': ' + PageContext[CONNECTION_TYPE]);
    debug(CONNECTION_TEST_RESULT + ': ' + PageContext[CONNECTION_TEST_RESULT]);
    debug(CONNECTION_KBPS + ': ' + PageContext[CONNECTION_KBPS]);
    debug(BANDWIDTH + ': ' + PageContext[BANDWIDTH]);
    debug('speedConnectionStatus: ' + speedConnectionStatus);
  };

  // start the SpeedTest. This does not rely on any third party script. DOM also must not be ready, so we can start right away
  initSpeedTest();

  testLocalStorage();

  // check if we have a mobile devise
  PageContext[IS_MOBILE_DEVICE] = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i
        .test(a) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
        .test(a.substr(0, 4))
    ) PageContext[IS_MOBILE_DEVICE] = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
})(PageContext, navigator, document, window);

PageHandle.setTargeting({
  mainRegex: /<div id="content".*?>/,
  mainSelector: '#content',
});

var DWBF_MOBILE;

var i18n = {
  'locales': ['de'], // insert the locales
  'defaultLocale': 'en',
  addKey: function (key, translationValueMap) {
    if (key) {
      for (var locale in translationValueMap) {
        if (!this['keys'][locale]) this['keys'][locale] = {};
        this['keys'][locale][key] = translationValueMap[locale];
      }
    }
  },
  keys: {
    /* ALWAYS MAINTAIN ENGLISH LANGUAGE KEYS FIRST! They are used as default fallback. */
    'en': {
      'global_link_more': '[more...]',
      'gMaps.click.to.activate':
        'Please click on the map to activate Google Maps.',
      'bad.ie.browser':
        'You are using an outdated browser. We recommend <a href="http://www.microsoft.com/en-us/download/details.aspx?id=43" target="_new">installing Internet Explorer 8</a> if this website is displayed in a broken way.',
      'caption.next': 'Next',
      'caption.previous': 'Previous',
      'caption.next.page': 'Next Page &gt;',
      'caption.previous.page': '&lt; Previous Page',
      'caption.pagination': 'Page {0} of {1}',
      'caption.all': 'All',
    },
    'de': {
      'global_link_more': '[mehr...]',
      'gMaps.click.to.activate':
        'Bitte klicke auf die Karte, um Google Maps zu aktivieren.',
      'bad.ie.browser':
        'Sie verwenden einen veralteten Browser. Wir empfehlen <a href="http://windows.microsoft.com/de-de/internet-explorer/download-ie" target="_new">den neuesten Internet Explorer zu installieren</a>, falls diese Webseite fehlerhaft angezeigt wird.',
      'caption.next': 'Weiter',
      'caption.previous': 'Zurück',
      'caption.next.page': 'Nächste Seite &gt;',
      'caption.previous.page': '&lt; Vorherige Seite',
      'caption.pagination': 'Seite {0} von {1}',
      'caption.all': 'Alle',
    },
    'el': {
      'global_link_more': '[περισσότερα...]',
      'gMaps.click.to.activate':
        'Παρακαλώ κλικάρετε στον χάρτη για να ενεργοποιήσετε τους Χάρτες Google.',
      'bad.ie.browser':
        'Χρησιμοποιείτε ένα παλιό πρόγραμμα περιήγησης ιστοσελίδων. Προτείνουμε να <a href="http://windows.microsoft.com/el-gr/internet-explorer/download-ie" target="_new">εγκαταστήσετε τον Internet Explorer 11</a> αν η ιστοσελίδα δεν εμφανίζεται σωστά.',
      'caption.next': 'Επόμενο',
      'caption.previous': 'Προηγούμενο',
    },
    'es': {
      'global_link_more': '[mas...]',
      'gMaps.click.to.activate':
        'Por favor hacer click en el mapa para activar Google Maps.',
      'bad.ie.browser':
        'Usted está usando un navegador desactualizado. Le recomendamos <a href="http://windows.microsoft.com/es-es/internet-explorer/download-ie" target="_new">instalar Internet Explorer 11</a> si esta página le aparece de manera incorrecta.',
      'caption.next': 'Siguiente',
      'caption.previous': 'Anterior',
    },
    'nl': {
      'global_link_more': '[meer...]',
      'gMaps.click.to.activate':
        'Klik op de kaart om Google Maps te activeren.',
      'bad.ie.browser':
        'Je gebruikt een oude browser. We raden aan om <a href="http://windows.microsoft.com/nl-nl/internet-explorer/download-ie" target="_new">Explorer 11 te installeren</a> bij gebrekkige weergave van deze site.',
      'caption.next': 'Volgende',
      'caption.previous': 'Vorige',
    },
    'fr': {
      'global_link_more': '[suite...]',
      'gMaps.click.to.activate':
        'Cliquez sur la carte pour activer Google Maps.',
      'bad.ie.browser':
        'Vous utilisez un navigateur dépassé. Nous vous recommandons <a href="http://windows.microsoft.com/fr-fr/internet-explorer/download-ie" target="_new">d\'installer Internet Explorer 11</a> si ce site ne s\'affiche pas correctement.',
      'caption.next': 'Suivant',
      'caption.previous': 'Précédent',
    },
    'pt': {
      'global_link_more': '[mais...]',
      'gMaps.click.to.activate':
        'Por favor clique no mapa para ativar Google Maps.',
      'bad.ie.browser':
        'Está a usar um navegador desatualizado. Nós recomendamos <a href="http://windows.microsoft.com/pt-pt/internet-explorer/download-ie" target="_new"> instalar Internet Explorer 11</a> se esta pagina aparece de maneira errada. ',
      'caption.next': 'Seguinte',
      'caption.previous': 'Anterior',
      'caption.next.page': 'Página seguinte',
      'caption.previous.page': 'Página anterior',
      'caption.pagination': 'Página',
      'caption.all': 'Tudo',
    },
  },
};

function translate(key) {
  var locale = i18n.locales[0],
    keys = i18n['keys'];
  return (keys[locale] && keys[locale][key])
    ? keys[locale][key]
    : keys[i18n.defaultLocale][key];
}

// the first argument is the resource key, the following 3 ones are used as format replacer
function translateF() {
  return translate(arguments[0]).format(
    arguments[1],
    arguments[2],
    arguments[3],
  );
}

//Translations
i18n.addKey('menu.hide', { en: 'Hide Menu', de: 'Menü verstecken' });
i18n.addKey('menu', { en: 'Menu', de: 'Menü' });
i18n.addKey('newsletter.signup', {
  en: 'Get the news via e-mail',
  de: 'erhalte die News per E-Mail',
});
i18n.addKey('newsletter.signup.reassurance.1', {
  en:
    'Thank you for signing up, but we need to verify your email address. Pleas click on the link in the email we have just send to you.',
  de:
    'Danke für Ihre Anmeldung, jedoch müssen wir Ihre E-Mail-Adresse noch bestätigen. Bitte klicken Sie auf den Link in der Email, die wir soeben an Sie geschickt haben.',
});
i18n.addKey('newsletter.signup.reassurance.2', {
  en: 'Thank you! You will now get the news directly in your inbox.',
  de:
    'Vielen Dank! Wir werden die News ab jetzt direkt in Ihren Posteingang senden.',
});
i18n.addKey('newsletter.email', { en: 'e-mail', de: 'E-Mail' });
i18n.addKey('donation.paypal.purpose', {
  en: '{0} (no. \\{1})',
  de: '{0} (Nr. \\{1})',
});

//technical newsletter signup translation keys
//this values correspond to the mailchimp lists, where the users are meant to signup to
i18n.addKey('newsletter.email.signup.listId', {
  en: '79b7198408',
  de: 'f4f4c1aad4',
});
i18n.addKey('newsletter.email.signup.dontFill', {
  en: 'b_0f47beb82895556cb97b6b7d8_79b7198408',
  de: 'b_0f47beb82895556cb97b6b7d8_f4f4c1aad4',
});

//Functions
function isMobileDisplay() {
  //DWBF_MOBILE = true;
  DWBF_MOBILE = PageContext.isMobileDevice();

  if (DWBF_MOBILE) {
    $('html').attr('id', 'bs-mobile');
  } else {
    $('html').attr('id', null);
  }
  return DWBF_MOBILE;
}
isMobileDisplay();

if (PageContext.user.loggedIn) PageHandle.setMode('pageload');

$(document).ready(function () {
  Page.init();
});

var Page = {
  scalingBuddha: {},
  currentBgID: null,
  sbWrapper: null,
  horizon: null,
  leftInner: null,
  right: null,
  content: null,
  wHeight: null, // window height
  wWidth: null, // window width
  bHeight: null, // buddha height
  inHeight: null, // height of the complete left content area
  innerPadding: 0,
  originalContentHeight: 0,
  transitionSpeed: 900,
  scaleOffsetPercent: 4,
  bgWidth: 1000,
  bgHeight: 1031,
  bgRatio: 0.969932104,
  initialized: false,
  init: function (fromCallback) {
    if (!this.initialized) {
      this.initialized = true;

      this.sbWrapper = this.getSbWrapper();
      this.right = $('#right');
      if (!fromCallback) this.changeBgImage();

      $(window).resize(function () {
        Page.heightAdjust(true);
      });

      if ($('.menu-link-wrapper').length === 0) {
        this.handleMenu();
      }
    }
  },
  handleMenu: function () {
    // this is the collapsed mobile menu
    // comes in from the site
    if (DWBF_MOBILE) {
      var menuElem = $('#navigation_visible'),
        expands = menuElem.find('#nav > li > .wrp > a'),
        hideButton = $(
          '<button class="fr link back-link mobile-hide-menu">' +
            translate('menu.hide') + '</button>',
        ),
        menuItem = $(
          '<div class="menu-link-wrapper"><span class="navicon"><span class="bar"></span><span class="bar"></span><span class="bar"></span></span><span class="mobile-menu-text">' +
            translate('menu') + '</span></div>',
        ),
        slideSpeed = 280;

      menuElem.prepend(hideButton);
      $('#main').prepend(menuItem);

      menuElem.data('widgetname', 'toggler');
      expands.addClass('trigger-toggle');
      menuElem.find('#nav > li > .wrp > ul').addClass('trigger-show');

      Widgets.initSpecific(menuElem[0], 'toggler', true); // force initialize the toggler

      menuElem.find('#nav > li.current > .wrp > a').addClass('expanded');
      menuElem.find('#nav > li.current > .wrp > ul').show();

      hideButton.click(function () {
        menuElem.parent().animate({ left: '-70%' }, slideSpeed);
      });

      menuItem.click(function () {
        menuElem.parent().animate({ left: '0%' }, slideSpeed);
      });
    }
  },
  heightAdjust: function (recheck) {
    var height = this.right.height(),
      width = this.right.width(),
      ratio = this.bgRatio,
      setWidth,
      navId = this.getNavigationID();

    this.getSbWrapper().width(height * ratio);
    if (recheck) ImageScaler.recheckImage(this.scalingBuddha[navId]);
  },
  getNavigationID: function () {
    var navId = $('#nav > .current').attr('id');
    return navId ? navId : 'top-nav-default';
  },
  getSbWrapper: function () {
    if (!this.sbWrapper) this.sbWrapper = $('#sb_wrapper');
    return this.sbWrapper;
  },
  scrollTop: function () {
    $('#scroll-fake').scrollTop(0);
  },
  changeBgImage: function () {
    var that = Page,
      navId = that.getNavigationID(),
      oldNavId = that.currentBgID,
      img;

    if (!that.initialized) that.init(true);

    if (oldNavId != navId) {
      that.currentBgID = navId;

      if (!that.scalingBuddha[navId]) { // load a new image
        img = $('<img class="scaling_buddha fs-img" id="sb-' + navId + '"/>');
        img.data({
          width: that.bgWidth,
          height: that.bgHeight,
          src: DWBF_VARS.BG_IMAGES[navId],
          'aspect-ratio': 'auto',
        }).css({ opacity: 0 });
        that.scalingBuddha[navId] = img;
        that.getSbWrapper().append(img);

        that.heightAdjust(false);

        ImageScaler.addImage(img);

        img.on('load', function () {
          Page.heightAdjust(true);
          if (that.currentBgID == navId) {
            that.fadeImages(
              that.scalingBuddha[navId],
              that.scalingBuddha[oldNavId],
            );
            // debug('fade from %s to %s', oldNavId, navId);
          }

          $(this).unbind('load');
        });
      } else { // this image is already there, just fade
        that.fadeImages(
          that.scalingBuddha[navId],
          that.scalingBuddha[oldNavId],
        );
        // debug('else fade from %s to %s', oldNavId, navId);
      }
    }
  },
  fadeImages: function (show, hide) {
    show.css({
      top: -this.scaleOffsetPercent + '%',
      right: -this.scaleOffsetPercent + '%',
      height: (100 + 2 * this.scaleOffsetPercent) + '%',
    }).animate(
      { opacity: 1, top: 0, right: 0, height: '100%' },
      this.transitionSpeed,
    );
    if (hide && hide.length) hide.animate({ opacity: 0 }, this.transitionSpeed);
  },
};

//the fader is the menu fade
Widgets.register('fader', function (el) {
  var elem = $(el);

  if (!DWBF_MOBILE) {
    var fadeInFct = function (el) {
        var elem = $(el);
        if (!elem.data('force')) {
          elem.data('visible', true).css('padding-bottom', 0);
          fade(
            elem.children('li').css('opacity', 0),
            1,
            fastSpeed,
            false,
            delay,
          );
          elem.stop().css({ 'display': 'block' }).animate({
            'padding-bottom': paddingBottom,
            'opacity': 1,
          }, fastSpeed);
        }
      },
      fadeOutFct = function (el, force) {
        var elem = $(el);
        if (!elem.data('force')) {
          elem.data('visible', false).data('force', force);
          fade(elem, 0, fastSpeed);
        }
      },
      fastSpeed = 400,
      delay = 250,
      paddingBottom = 28;

    elem.children('.wrp').children('ul').css('opacity', 0);

    elem.bind('click', function () {
      var el = $(this).children('.wrp').children('ul');
      if (el.data('visible')) {
        fadeOutFct(el, true);
      } else {
        fadeInFct(el);
      }
    });

    elem.bind('mouseenter', function () {
      fadeInFct($(this).children('.wrp').children('ul').data('force', false));
    });

    elem.bind('mouseleave', function () {
      fadeOutFct($(this).children('.wrp').children('ul'));
    });

    elem.children('.wrp').children('ul').find('a').click({
      target: elem.children('.wrp').children('ul'),
    }, function (e) {
      var el = e.data.target;
      if (el.data('visible')) fadeOutFct(el, true);
    });
  }
});

Widgets.register(
  'sort-columns',
  function (el) {
    var elem = $(el);
    if (elem.parent().parent().attr('id') == 'top-nav-2') { // only sort on Centers
      var listitems = elem.children().get(),
        colWidthString = elem.children().css('width').toString(),
        isPercent = colWidthString.substring(
          colWidthString.length - 1,
          colWidthString.length,
        ),
        overallWidth = isPercent ? 100 : elem.width(),
        collWidth = parseFloat(colWidthString),
        colCount = Math.round(overallWidth / collWidth) == 0
          ? 1
          : Math.round(overallWidth / collWidth),
        ix,
        i,
        k;

      listitems = listitems.filter((a) => $(a).hasClass('category-item'));
      listitems.sort(function (a, b) {
        var compA = $(a).find('a').text().toUpperCase();
        var compB = $(b).find('a').text().toUpperCase();

        if (compB == 'CENTERS' || compB == 'ZENTREN') return 1; // centers should be first
        if (compA == 'CENTERS' || compA == 'ZENTREN') return -1; // Safari needs this...
        return (compA < compB) ? -1 : (compA > compB) ? 1 : 0;
      });

      var rowCount = Math.ceil(listitems.length / colCount);

      elem.empty();

      for (i = 0; i < rowCount; i++) {
        ix = [i, i + rowCount, i + rowCount * 2];
        for (k = 0; k < colCount; k++) {
          if (ix[k] < listitems.length) {
            elem.append(listitems[ix[k]]);
          } else {
            elem.append('<li><a>&nbsp;</a></li>');
          }
        }
      }
    }
  },
  false,
  100,
);

Widgets.register('sticky-menu', function (el) {
  var elem = $(el);
  var bd = $('#scroll-fake'),
    page = $('#page'),
    parent = elem.parent(),
    main = $('#main-wrapper'),
    height = elem.height(),
    topBorder = parseInt(main.css('top')),
    menu = elem,
    offset = 80,
    fastSpeed = 300,
    slowSpeed = 800,
    topOut = -height - 33,
    scrollTopForMenuModeChange = topBorder + height, //+ offset
    shadow = elem.find('.fw-shadow'),
    width;

  bd.scroll(function () {
    if (bd.scrollTop() > scrollTopForMenuModeChange) {
      if (!elem.data('isFixed')) {
        elem.data('isFixed', true);
        width = elem.width();
        fade(elem, 0, fastSpeed, function (el) {
          var newWidth = 100 * width / bd.width();
          page.append(
            el.css({
              position: 'absolute',
              top: topOut,
              width: newWidth + '%',
              opacity: 1,
              display: 'block',
            }),
          );
          el.animate({ top: -7 }, slowSpeed);
          fade(shadow, 0.4, slowSpeed);
          // fade(, 1, fadeInSpeed);
        });
      }
    } else if (elem.data('isFixed')) {
      elem.data('isFixed', false).animate(
        { top: topOut },
        fastSpeed,
        function () {
          parent.prepend(
            $(this).hide().css({
              position: 'absolute',
              top: topBorder,
              width: '100%',
            }),
          );
          fade($(this), 1, fastSpeed);
          shadow.hide();
        },
      );
    }
  });
});

Widgets.register('ajax-menu', function (el) {
  var elem = $(el);
  PageHandle.registerAjaxMenu(elem);
});

Widgets.register('ajax-menu-second-level', function (el) {
  var elem = $(el);
  elem.click(function (e) {
    e.stopPropagation();
    var url = (new URL(el.attr('href'))).makeRelative();
    PageHandle.updateMain(url);
    return false;
  });
});

Widgets.register('boxheight', function (el) {
  var elem = $(el);
  var boxes = elem.find('.inf-box'),
    putSizes = function (elems) {
      var currentTop = null,
        currentHeight,
        row = null;

      elems.each(function () {
        var elem = $(this),
          top,
          height;

        if (elem.is(':visible')) {
          top = elem.offset().top;
          height = elem.height();

          if (top != currentTop) {
            // end case
            if (row && row.length > 1) row.height(currentHeight);

            row = elem;
            currentTop = top;
            currentHeight = height;
          } else {
            // row case
            row = row.add(elem);
            if (height > currentHeight) currentHeight = height;
          }
        }
      });
    };

  putSizes(boxes);

  $(window).resize(function () {
    putSizes(boxes);
  });
});

//placeholder widget workaround
Widgets.register('placeholder', function (el) {
  var elem = $(el);
  var pt = elem.data('placeholder');
  elem.attr('placeholder', pt).attr('title', pt);
});

//newsletter signup shorthand widget
Widgets.register('newsletter-signup', function (el) {
  var elem = $(el);
  var span = $(
      '<span class="nl-signup-link">' + translate('newsletter.signup') +
        '</span>',
    ),
    form = $(
      '<form action="//buddhism-foundation.us9.list-manage.com/subscribe/post?u=0f47beb82895556cb97b6b7d8&amp;id=' +
        translate('newsletter.email.signup.listId') +
        '" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_self"><input type="email" value="" placeholder="' +
        translate('newsletter.email') +
        '" name="EMAIL" class="required email" id="mce-EMAIL"/><button type="submit" name="subscribe" class="" id="mc-embedded-subscribe"><span class="icon"></span></button><!-- real people should not fill this in and expect good things - do not remove this or risk form bot si0nups--><div style="position: absolute; left: -5000px;"><input type="text" value="" name="' +
        translate('newsletter.email.signup.dontFill') +
        '" tabindex="-1"></div></form>',
    ).hide(),
    message,
    url = new URL();

  elem.empty();
  elem.append(span).append(form);

  span.click(function (e) {
    span.animate({ opacity: 0 }, 200);
    form.css({ opacity: 0 }).show().animate({ opacity: 1 }, 200);
  });

  // additional messaging
  switch (url.getParameter('signup')) {
    case '1':
    case '2':
      message = $(
        '<p class="message info">' +
          translate(
            'newsletter.signup.reassurance.' + url.getParameter('signup'),
          ) + '</p>',
      ).hide();
      elem.closest('.blog_wrapper').parent().prepend(message);
      message.slideDown(220).click(function () {
        $(this).slideUp(200);
      });
      break;
  }
});

Widgets.register('toggler', function (el) {
  var elem = $(el);
  var hashPre = '_',
    expandClass = 'expanded',
    getName = function (el) {
      var elem = $(el);
      return elem.text().toLowerCase().replace(/[,;+\-\.&äöüß]/g, '').replace(
        /\s/g,
        '-',
      );
    },
    links = elem.find('.trigger-toggle'),
    currentActive = window.location.hash.substr(hashPre.length + 1);

  elem.find('.trigger-show').hide();
  links.addClass('expand_link').click(function () {
    var el = $(this),
      name = hashPre + getName(el),
      info = el.parent().find('.trigger-show'),
      delay = 300,
      currentLink = elem.find('.' + expandClass),
      currentInfo = currentLink.parent().find('.trigger-show'),
      cHeight = $('#content_inner').outerHeight(),
      preOpen;

    // Page.animateHeight(cHeight + (info.outerHeight(true) - currentInfo.outerHeight(true)) , delay) // animate the page also, in order to adjust the height and assure the filling.

    if (window.location.hash == '#' + name) window.location.hash = hashPre;

    if (!el.hasClass(expandClass)) {
      window.location.hash = name;
      el.addClass(expandClass);
      UI.slideDown(info, delay);
    }

    UI.slideUp(currentInfo, delay);
    currentLink.removeClass(expandClass);
  }).each(function () {
    // inital scroll handling
    var link = $(this);
    if (getName(link) == currentActive) {
      link.addClass(expandClass).parent().find('.trigger-show').show();

      $('#scroll-fake').scrollTop(link.offset().top - 50);
    }
  });
});

Widgets.register('innerfade', function (el) {
  var elem = $(el);
  elem.innerfade(myEval(elem.data('config')));
});

Widgets.register('scale-img', function (el) {
  var elem = $(el);
});

Widgets.register(
  'bsd-center-navigation',
  function (el) {
    var elem = $(el);
    var target = elem.data('target')
        ? elem.data('target')
        : '#top-nav-2 > .wrp > ul',
      menClone = $('#navigation_visible #nav ' + target).clone();

    menClone.addClass('center-menu').appendTo(elem.empty());

    elem.find('li, ul').attr('style', '');
    elem.find('li').each(function () {
      var el = $(this);
      if (el.children('.wrp').children('ul').length) {
        el.addClass('whide');
      }
    });

    // we are also using the ajax menu functionality on this
    Widgets.initSpecific(el, 'ajax-menu', true);
  },
  false,
  80,
);

var UI = {
  resetDimensions: {
    'height': 0,
    'padding-top': 0,
    'padding-bottom': 0,
    'display': 'block',
    'margin-top': 0,
    'margin-bottom': 0,
    'overflow': 'hidden',
  },
  clearDimensions: {
    'height': '',
    'padding-top': '',
    'padding-bottom': '',
    'margin-top': '',
    'margin-bottom': '',
    'overflow': '',
  },
  animationDefaultTime: 200,
  slideDown: function (el, delay) {
    var elem = $(el);
    if (elem.length) {
      var dimensions = {
        'height': elem.height(),
        'padding-top': parseInt(elem.css('padding-top')),
        'padding-bottom': parseInt(elem.css('padding-bottom')),
        'margin-top': parseInt(elem.css('margin-top')),
        'margin-bottom': parseInt(elem.css('margin-bottom')),
      };

      elem.css(this.resetDimensions).animate(
        dimensions,
        (delay === undefined) ? this.animationDefaultTime : delay,
        function () {
          $(this).css(UI.clearDimensions);
        },
      );
    }
  },
  slideUp: function (el, delay) {
    var elem = $(el);
    if (elem.length) {
      elem.css('overflow', 'hidden').animate(
        this.resetDimensions,
        (delay === undefined) ? this.animationDefaultTime : delay,
        function () {
          $(this).hide().css(UI.clearDimensions);
        },
      );
    }
  },
};

PageHandle.registerCallback(
  'afterUpdateMain',
  Page.changeBgImage,
  'foundationChange',
);
PageHandle.registerCallback(
  'beforeUpdateMain',
  Page.scrollTop,
  'foundationScrollTop',
);
PageHandle.registerCallback('beforeUpdateMain', function () {
  $('body').removeClass('es-page-ex');
}, 'removeHomePage');

/* =========================================================

//jquery.innerfade.js

//Datum: 2008-02-14
//Firma: Medienfreunde Hofmann & Baldes GbR
//Author: Torsten Baldes
//Mail: t.baldes@medienfreunde.com
//Web: http://medienfreunde.com

//based on the work of Matt Oakes http://portfolio.gizone.co.uk/applications/slideshow/
//and Ralf S. Engelschall http://trainofthoughts.org/

*
*  <ul id="news">
*      <li>content 1</li>
*      <li>content 2</li>
*      <li>content 3</li>
*  </ul>
*
*  $('#news').innerfade({
*	  animationtype: Type of animation 'fade' or 'slide' (Default: 'fade'),
*	  speed: Fading-/Sliding-Speed in milliseconds or keywords (slow, normal or fast) (Default: 'normal'),
*	  timeout: Time between the fades in milliseconds (Default: '2000'),
*	  type: Type of slideshow: 'sequence', 'random' or 'random_start' (Default: 'sequence'),
* 		containerheight: Height of the containing element in any css-height-value (Default: 'auto'),
*	  runningclass: CSS-Class which the container getâ€™s applied (Default: 'innerfade'),
*	  children: optional children selector (Default: null)
*  });
*

//========================================================= */

var elements,
  nexImg,
  loadstart,
  afterloadlength = 0,
  current,
  newslide,
  prevslide,
  settings = {
    'animationtype': 'fade',
    'speed': 'normal',
    'type': 'sequence',
    'timeout': 2000,
    'containerheight': 'auto',
    'runningclass': 'innerfade',
    'children': null,
    'ajaximagelist': false,
    'mode': 'autostart',
    'behavioure': 'overlay', // behaviour for manual mode. Can be overlay (Simple buttons for navigation) or zoom (trys to open a lightbox with the full images, etc.)
    'prevslide': 0,
    'newslide': 0,
    'current': 0,
    'name': 'gal-' + (new Date()).getTime(),
  };

$.fn.innerfade = function (options) {
  return this.each(function () {
    $.innerfade($(this), options);
  });
};

$.innerfade = function (container, options) {
  if (options) $.extend(settings, options);

  if (settings.children === null) {
    elements = $(container).children('.use');
  } else {
    elements = $(container).children(settings.children);
  }

  if (elements.length > 1) {
    container.css('position', 'relative').css(
      'height',
      settings.containerheight,
    ).addClass(settings.runningclass);

    $(elements[0]).data('loaded', true);

    for (var i = 0; i < elements.length; i++) {
      $(elements[i]).css('z-index', String(elements.length - i)).css(
        'position',
        'absolute',
      );
      if (i > 0) $(elements[i]).hide();
    }

    settings.prevslide = elements.length - 1;
    settings.newslide = 1;
    $.innerfade.startNext(elements, settings, container);

    // add the buttons for manual
    if (settings.mode == 'manual') {
      var nextBtn = $(
          '<span class="nextBtn slideshowBtn" title="' +
            translate('caption.next') + '">' + translate('caption.next') +
            '</span>',
        ).bind('click', function () {
          $.innerfade.next(elements, settings, container);
        }),
        prevBtn = $(
          '<span class="prevBtn slideshowBtn" title="' +
            translate('caption.previous') + '">' +
            translate('caption.previous') + '</span>',
        ).bind('click', function () {
          settings.newslide = settings.prevslide;
          $.innerfade.next(elements, settings, container);
        }),
        buttons = $('<div class="buttons"></div>').append(prevBtn).append(
          nextBtn,
        );

      container.parent().append(buttons);
    }
  }

  // add all the functions for a image gallerie
  if (settings.mode == 'manual' && settings.behavioure == 'zoom') {
    $.innerfade.makeGallerie(settings, container.find('a'), container);
  }
};

$.innerfade.makeGallerie = function (settings, links, root) {
  links.each(function () {
    var elem = $(this);
    if (elem.attr('rel') != settings.name && elem.find('img').length) {
      elem.attr('rel', settings.name).addClass('widget fancybox').data(
        'widgetname',
        'popup',
      ).attr('title', elem.find('img').attr('alt'));
    }
  });

  Widgets.init(root);
};

// @param Array elements - The actual childen of the list
$.innerfade.startNext = function (elements, settings, container) {
  if (settings.type == 'sequence') {
    // now we check, if we have a existing element or need to insert a dynamic element
    if ($(elements[settings.newslide]).data('loaded')) {
      if (settings.mode != 'manual') {
        setTimeout(function () {
          $.innerfade.next(elements, settings, container);
        }, settings.timeout);
      }
    } else {
      var firstImg = $(elements[0]).find('img'),
        cont = $(elements[settings.newslide]),
        wrapper = $('<span class="es-responsive-img-wrapper"></span>').css({
          width: '100%',
          height: 'auto',
        }),
        hasLink = false,
        insertElem;

      if (cont.find('a').length) {
        insertElem = cont.find('a');
        hasLink = true;
      } else {
        insertElem = cont;
      }

      loadstart = new Date();
      loadstart = loadstart.getTime();

      cont.parent().css('height', firstImg.data('height'));
      nexImg = $(
        '<img class="fs-img" data-aspect-ratio="auto" alt="' +
          settings.ajaximagelist[settings.newslide - 1].alt + '" data-src="' +
          settings.ajaximagelist[settings.newslide - 1].url + '" data-width="' +
          firstImg.data('width') + '" data-height="' + firstImg.data('height') +
          '" title="' + settings.ajaximagelist[settings.newslide - 1].alt +
          '" />',
      ).bind('error', function () {
        debug('Loading Image failed');
      }).bind('load', function () {
        var timeout, delta, loadend = new Date(), elem = $(this);

        cont.data('loaded', true);

        elem.attr('data-height', this.height);
        elem.attr('data-width', this.width);
        //foresight.initAfter(elem);

        if (hasLink) $.innerfade.makeGallerie(settings, insertElem, cont);

        if (settings.mode != 'manual') {
          delta = loadend - loadstart;
          timeout = (settings.timeout > delta) ? settings.timeout - delta : 0;

          setTimeout(function () {
            $.innerfade.next(elements, settings, container);
          }, timeout);
        }

        elem.unbind('load');
      });

      wrapper.append(nexImg);
      insertElem.closest('li').css({ opacity: 0, display: 'block' }).prepend(
        wrapper,
      );

      // use the ImageScaler magic to generate the source
      ImageScaler.addImage(nexImg);
    }
  } else if (settings.type == 'random') {
    settings.current = Math.floor(Math.random() * (elements.length));

    if (settings.mode != 'manual') {
      setTimeout(function () {
        do {
          settings.newslide = Math.floor(Math.random() * (elements.length));
        } while (settings.current == settings.newslide);
        $.innerfade.next(elements, settings, container);
      }, settings.timeout);
    } else {
      // TODO: set prev and next
    }

    $(elements[last]).show();
  } else if (settings.type == 'random_start') {
    settings.type = 'sequence';
    var current = Math.floor(Math.random() * (elements.length));

    if (settings.mode != 'manual') {
      setTimeout(function () {
        $.innerfade.next(
          elements,
          settings,
          (current + 1) % elements.length,
          current,
          container,
        );
      }, settings.timeout);
    } else {
      // TODO: set prev and next
    }
    $(elements[current]).show();
  } else {
    debug(
      "Innerfade-Type must either be 'sequence', 'random' or 'random_start'",
    );
  }
};

$.innerfade.next = function (elements, settings, container) {
  var length = elements.length,
    newElem = $(elements[settings.newslide]),
    nexImg,
    loadstart;

  newElem.css({ opacity: 0, display: 'block' });
  if (newElem.find('img').attr('src')) {
    ImageScaler.recheckImage(newElem.find('img')); // check, if the size changed meanwhile
  }
  newElem.css({ opacity: '', display: 'none' });

  // do the transition
  if (settings.animationtype == 'slide') {
    $(elements[settings.current]).slideUp(settings.speed);
    newElem.css().slideDown(settings.speed);
  } else if (settings.animationtype == 'fade') {
    fade($(elements[settings.current]), 0, settings.speed);
    fade(newElem, 1, settings.speed);
  } else {
    alert("Innerfade-animationtype must either be 'slide' or 'fade'");
  }

  // claculate the new values
  if (settings.type == 'sequence') {
    if ((settings.newslide + 1) < length) {
      settings.current = settings.newslide;
      settings.newslide = settings.newslide + 1;
      settings.prevslide = (settings.current > 0)
        ? settings.current - 1
        : length - 1;
    } else {
      settings.newslide = 0;
      settings.current = length - 1;
      settings.prevslide = (settings.current > 1)
        ? settings.current - 1
        : length - 1;
    }
  } else if (settings.type == 'random') {
    settings.current = settings.newslide;
    while (settings.newslide == settings.current) {
      settings.newslide = Math.floor(Math.random() * length);
    }
  } else {
    alert(
      "Innerfade-Type must either be 'sequence', 'random' or 'random_start'",
    );
  }

  $.innerfade.startNext(elements, settings, container);
};
